var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidenav-wrapper"},[_c('div',{},[_c('GroupSideNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }